import axios from 'axios';

const apiClient = axios.create();

export { apiClient };
